import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import type { Service } from '~publish/contexts/AccountContext/graphqlEnums'
import {
  connectChannel,
  toConnectableService,
} from '~publish/helpers/channelConnections'
import { actions } from '~publish/legacy/profiles-disconnected-modal/reducer'

type ReconnectOptions = {
  id: string
  service: Service
  cta?: CTA
  authMethod?: string
}

export const useReconnectChannel = (): ((opts: ReconnectOptions) => void) => {
  const dispatch = useDispatch()

  const handleReconnectChannel = useCallback(
    ({ id, service, cta, authMethod }: ReconnectOptions) => {
      const connectableService = toConnectableService(service)

      if (connectableService) {
        connectChannel({
          service: connectableService,
          isRefreshingConnection: true,
          cta,
          authMethod,
        })
      }

      dispatch(
        actions.reconnectProfile({
          id,
          service,
        }),
      )
    },
    [dispatch],
  )

  return handleReconnectChannel
}
